import { useInitializeOfflineData, useToast } from "duck";
import {
  GetUsersDocument,
  useCreateUserMutation,
  UserRoleEnum
} from "requests";
import { FormValues } from "../../../duck";

export const useCreateUser = (onSuccess: () => void) => {
  const { loadUsers } = useInitializeOfflineData();

  const toast = useToast({ status: "success" });

  const [createUser] = useCreateUserMutation({ ignoreResults: true });

  return (values: FormValues) =>
    createUser({
      variables: {
        input: {
          active: true,
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          plainPassword: values.password,
          plainPin: Number(values.pin),
          userRole: values.userRole as UserRoleEnum
        }
      },
      refetchQueries: [GetUsersDocument]
    }).then(data => {
      loadUsers();

      if (data) {
        onSuccess();
        toast({ description: "User is created successfully." });
      }
    });
};
